export default __webpack_public_path__ + "static/media/img4.02e0e43f.jpg";